<div class="cnt-page-internal">
    <div class="row-title">
        <!-- <teiasoft-title [title]="'costingTool.title' | translate"></teiasoft-title> -->
        <div>
            <teiasoft-title [title]="title"></teiasoft-title>
            <ng-container>
                <span *ngIf="item">{{'grid.CustomerItemNo' | translate}} <strong>{{item.customerItemNo}}</strong> /
                    {{'grid.Length' | translate}}
                    <strong *ngIf="item.lengthType === 'FL'">
                        <ng-container *ngIf="!item.multipleLength">{{item.lengthNominal}}
                            {{item.lengthUom}}</ng-container>
                        <ng-container *ngIf="item.multipleLength">{{item.lengthNominal}} {{item.lengthUom}} -
                            ({{item.lengthMin}} {{item.lengthUom}} - {{item.lengthMax}} {{item.lengthUom}})
                        </ng-container>
                    </strong>
                </span>
                <span>
                    <span><strong *ngIf="item?.lengthType === 'RL'">{{item?.lengthMin}} -
                            {{item?.lengthMax}}
                            {{item?.lengthUom}}</strong></span>
                </span>
            </ng-container>

        </div>
        <teiasoft-toolbar *ngIf="origin != ''" [buttonsList]="buttonsListBack" [theme]="globals.theme!"
            (onBtnClick)="onBtnToolbarClick($event)"></teiasoft-toolbar>
    </div>

    <ng-container *ngIf="filtersOptionReady">
        <div class="row-filters" [ngClass]="{'no-border-bottom': showAdditionalSelections}"
            (keydown)="onKeyDown($event)">
            <div class="cnt-filters filter-span-1">
                <teiasoft-select [labelText]="'costingTool.rmGrade' | translate" [optionsList]="rmGradeOptionList"
                    [isRequired]="true" style="width:100%; height:7.7vh" [noMinWidth]="true"
                    [defaultValue]="rawMaterialGrade" (onSelected)="onSelectedRm($event)" [clearValue]="clearValue"
                    [removeFixedFromOptCnt]="true" [disabled]="filtersDisabled()"></teiasoft-select>
            </div>
            <!-- <div class="cnt-filters">
                <teiasoft-select [labelText]="'costingTool.alloySurcharge' | translate" [optionsList]="alloyOptionList"
                    [isRequired]="true" style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="asIncluded"
                    (onSelected)="onSelectedAS($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                    [disabled]="filtersDisabled()"></teiasoft-select>
            </div> -->
            <div class="cnt-filters filter-span-half">
                <teiasoft-input [labelText]="getMeasureFilterLabel('costingTool.od')" style="width:100%"
                    [noMargin]="true" [value]="od" [clearValue]="clearValue" (onInput)="onInputOd($event)"
                    [isRequired]="odRequired" [type]="'number'" [roundDigits]="getRoundDigits('od')"
                    [limitDecimalDigits]="true" [disabled]="filtersDisabled()"></teiasoft-input>
            </div>
            <div class="cnt-filters filter-span-half">
                <teiasoft-input [labelText]="getMeasureFilterLabel('costingTool.averageWT')" style="width:100%"
                    [noMargin]="true" [value]="wt" [clearValue]="clearValue" (onInput)="onInputWt($event)"
                    [isRequired]="odRequired" [type]="'number'" [roundDigits]="getRoundDigits('wt')"
                    [limitDecimalDigits]="true" [disabled]="filtersDisabled()"></teiasoft-input>
            </div>
            <div class="cnt-filters filter-span-half">
                <teiasoft-input [labelText]="getMeasureFilterLabel('costingTool.id')" style="width:100%"
                    [noMargin]="true" [value]="id" [clearValue]="clearValue" (onInput)="onInputId($event)"
                    [isRequired]="odRequired" [type]="'number'" [roundDigits]="getRoundDigits('id')"
                    [limitDecimalDigits]="true" [disabled]="filtersDisabled()"></teiasoft-input>
            </div>
            <div class="cnt-filters filter-span-1" [ngClass]="{'edit-enquiry-toolbar': origin === 'edit-enquiry'}">
                <teiasoft-toolbar *ngIf="origin === '' || origin == 'record-id'" [buttonsList]="buttonsList"
                    [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
                    style="width: 100%; margin-top: 1.3vh;"></teiasoft-toolbar>
                <!-- THIS MARGIN IS NECESSARY BEACUSE THIS SELECT HAS NO LABEL -->
                <teiasoft-toolbar *ngIf="origin === 'edit-enquiry'" [buttonsList]="buttonsList" [theme]="globals.theme!"
                    (onBtnClick)="onBtnToolbarClick($event)"
                    style="width: 100%;margin-bottom: 0.7vh;"></teiasoft-toolbar>
            </div>
            <div class="cnt-filters filter-span-1"></div>
            <div class="cnt-filters filter-span-1">
                <teiasoft-select *ngIf="masterDataVersions && masterDataVersions.length > 0"
                    [labelText]="'grid.Version' | translate" [optionsList]="versionsOptionList" [noMinWidth]="true"
                    [defaultValue]="selectedVersionId" (onSelected)="onSelectedVersion($event)" [disabled]="true"
                    [disableOptionSort]="true" [removeFixedFromOptCnt]="true"></teiasoft-select>
                <span
                    *ngIf="!masterDataVersions || masterDataVersions.length == 0">{{'commons.noMasterDataVersions'}}</span>
            </div>
            <div class="cnt-filters filter-span-1">
                <teiasoft-select [labelText]="'grid.UnitSystem' | translate" [optionsList]="unitSystemOptionList"
                    style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="unitSystem"
                    (onSelected)="onSelectedUnitSystem($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                    [disabled]="contextSelectionDisabled || filtersDisabled()"></teiasoft-select>
            </div>
            <div class="cnt-filters filter-span-half">
                <teiasoft-select [labelText]="'grid.Currency' | translate" [optionsList]="currencyOptionList"
                    style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="currency"
                    (onSelected)="onSelectedCurrency($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                    [disabled]="contextSelectionDisabled || filtersDisabled()"></teiasoft-select>
            </div>
        </div>

        <!-- ADDITIONAL SELECTIONS -->
        <div class="row-additional" style="display: none;" (keydown)="onKeyDown($event)">
            <teiasoft-title [title]="'costingTool.additionalSelections' | translate" [size]="'medium'"></teiasoft-title>
            <div class="row-filters">

                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.ut' | translate" [optionsList]="utOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="ut"
                        (onSelected)="onSelectedUt($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.hydro' | translate" [optionsList]="hydroOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="hydro"
                        (onSelected)="onSelectedHydro($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>

                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.htHot' | translate" [optionsList]="htHotOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="htHot"
                        (onSelected)="onSelectedHtHot($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.htCold' | translate" [optionsList]="htColdOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="htCold"
                        (onSelected)="onSelectedHtCold($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.htAdd' | translate" [optionsList]="htAddOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="htAdd"
                        (onSelected)="onSelectedHtAdd($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>



                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.lgType' | translate" [optionsList]="lgTypeOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="lengthType"
                        (onSelected)="onSelectedLgType($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-1">
                    <teiasoft-input [labelText]="getMeasureFilterLabel('costingTool.lengthMin')" style="width:100%"
                        [noMargin]="true" [value]="lengthMin" [clearValue]="clearValue"
                        (onInput)="onInputLengthMin($event)" [isRequired]="odRequired" [type]="'number'"
                        [roundDigits]="getRoundDigits('lengthMin')" [limitDecimalDigits]="true"
                        [disabled]="filtersDisabled() || !lengthType"></teiasoft-input>
                </div>
                <div class="cnt-filters filter-span-1">
                    <teiasoft-input [labelText]="getMeasureFilterLabel('costingTool.lengthMax')" style="width:100%"
                        [noMargin]="true" [value]="lengthMax" [clearValue]="clearValue"
                        (onInput)="onInputLengthMax($event)" [isRequired]="odRequired" [type]="'number'"
                        [roundDigits]="getRoundDigits('lengthMax')" [limitDecimalDigits]="true"
                        [disabled]="filtersDisabled() || !lengthType || lengthType === 'FL'"></teiasoft-input>

                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.uBend' | translate" [optionsList]="uBendOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="uBent"
                        (onSelected)="onSelectedUBend($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.testCondition' | translate"
                        [optionsList]="testConditionOptionList" style="width:100%; height:7.7vh" [noMinWidth]="true"
                        [defaultValue]="testCondition" (onSelected)="onSelectedTestCondition($event)"
                        [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.process' | translate" [optionsList]="processOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="process"
                        (onSelected)="onSelectedProcess($event)" [clearValue]="clearValue"
                        [removeFixedFromOptCnt]="true" [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-half">
                    <teiasoft-select [labelText]="'costingTool.plant' | translate" [optionsList]="plantOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="plant"
                        (onSelected)="onSelectedPlant($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
            </div>
            <div class="row-filters">

                <div class="cnt-filters filter-span-1">
                    <teiasoft-select [labelText]="'costingTool.endsCondition' | translate"
                        [optionsList]="endsConditionOptionList" style="width:100%; height:7.7vh" [noMinWidth]="true"
                        [defaultValue]="endsCondition" (onSelected)="onSelectedEndsCondition($event)"
                        [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>

                <div class="cnt-filters filter-span-2">
                    <teiasoft-select [labelText]="'costingTool.sql' | translate" [optionsList]="sqlOptionList"
                        style="width:100%; height:7.7vh" [noMinWidth]="true" [defaultValue]="sql"
                        (onSelected)="onSelectedSql($event)" [clearValue]="clearValue" [removeFixedFromOptCnt]="true"
                        [disabled]="filtersDisabled()"></teiasoft-select>
                </div>
                <div class="cnt-filters filter-span-1"></div>
                <div class="cnt-filters filter-span-1"></div>
                <div class="cnt-filters filter-span-1"></div>
            </div>
        </div>
    </ng-container>
    <!-- GRID RESULTS -->
    <div *ngIf="isSubmit && resultDataset && resultDataset.length > 0" class="cnt-grid">
        <teiasoft-grid [title]="resultGridName" [gridDescription]="'costingTool.result' | translate"
            [customIcoCols]="customIcoColsResult" [columnsToShow]="columnsToShowResult"
            [gridConfiguration]="resultGridConfiguration" [dataSet]="resultDataset" [showFooter]="false"
            [selectable]="false" [theme]="globals.theme!" [autoWidth]="true" [showEditIcon]="false"
            [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!" [sortable]="false"
            (customIconClick)="customIconClickResult($event)" [enquiryNo]="enquiryNo!" [gridName]="resultGridName"
            [origin]="'edit-enquiry'" [hasSummaryRow]="true" [columnsToHighlightBig]="columnsToHighlightBigResult"
            [columnsToHighlight]="columnsToHighlightResult"
            [customHeaderRenderers]="customHeaderRenderers"></teiasoft-grid>
    </div>

    <div *ngIf="isSubmit && resultDataset && resultDataset.length == 0" class="cnt-grid no-overflow">
        <teiasoft-title [title]="'costingTool.result' | translate" [size]="'medium'"></teiasoft-title>
        <span class="no-data">{{'costingTool.noData' | translate}}</span>
    </div>

    <!-- GRID NEAREST -->
    <div *ngIf="isSubmit && nearestDataset && nearestDataset.length > 0" class="cnt-grid">
        <teiasoft-grid [title]="nearestGridName" [gridDescription]="'costingTool.nearest' | translate"
            [customIcoCols]="customIcoColsNearest" [columnsToShow]="columnsToShowResult"
            [gridConfiguration]="nearestGridConfiguration" [dataSet]="nearestDataset" [showFooter]="false"
            [selectable]="false" [theme]="globals.theme!" [autoWidth]="true" [showEditIcon]="false"
            [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!" [sortable]="false"
            (customIconClick)="customIconClickNearest($event)" [enquiryNo]="enquiryNo!" [gridName]="nearestGridName"
            [origin]="'edit-enquiry'" [columnsToHighlightBig]="columnsToHighlightBigNearest"
            [columnsToHighlight]="columnsToHighlightNearest" [hasSummaryRow]="true"
            [customHeaderRenderers]="customHeaderRenderers"></teiasoft-grid>
    </div>

    <div *ngIf="isSubmit && nearestDataset && nearestDataset.length == 0 && costsSourceCostingToolRecordId == null"
        class="cnt-grid no-overflow">
        <teiasoft-title [title]="'costingTool.nearest' | translate" [size]="'medium'"></teiasoft-title>
        <span class="no-data">{{'costingTool.noData' | translate}}</span>
    </div>
    <!-- TEMP TO REMOVE -->
    <!-- <button *ngIf="origin != ''" (click)="backToOrigin()">BACK</button> -->
</div>

<teiasoft-modal (onConfirmClick)="onConfirmModal($event)" [theme]="globals.theme!"
    [isMobile]="!globals.isDesktop!"></teiasoft-modal>

<ng-template #costingToolHeader let-column="column">
    <span>{{getGridHeaderLabel(column)}}</span>
</ng-template>
